import ChartTextInput from './ChartTextInput'

export default ChartTextInput
